/**
 * @deprecated use same function from '@alilc/lowcode-utils' instead
 */
export function isPlainObject(value) {
  if (typeof value !== 'object') {
    return false;
  }
  var proto = Object.getPrototypeOf(value);
  return proto === Object.prototype || proto === null || Object.getPrototypeOf(proto) === null;
}